import { Tooltip } from "antd";
import { ColumnType } from "antd/es/table";
import { USER_SCOPE_TEXTS, UserListEntity, UserStatus } from "interfaces";
import { Status } from "ui";
import { dateFormat, getPhone } from "utils";
import { ListOfRoles } from "components";

import styles from "./userList.module.css";

export const getColumns = (): Array<ColumnType<UserListEntity>> => {
  return [
    {
      dataIndex: "surname",
      key: "surname",
      title: "ФИО",
      width: 260,
      className: `text-clamp-ellipsis ${styles.userFullName}`,
      render: (_: any, record: UserListEntity) => {
        return (
          <Tooltip
            trigger="hover"
            placement="topLeft"
            title={`${record.surname} ${record.name} ${record.secondName ?? ""}`}
          >
            <span>
              {record.surname} {record.name} {record.secondName ?? ""}
            </span>
          </Tooltip>
        );
      },
    },
    {
      dataIndex: "phone",
      key: "phone",
      title: "Телефон",
      width: 200,
      render: (phone: number) => {
        return getPhone(phone);
      },
    },
    {
      dataIndex: "statusDate",
      key: "statusDate",
      title: "Дата обновления",
      width: 180,
      render: (statusDate: Date | string) => {
        return dateFormat(statusDate, true);
      },
    },
    {
      dataIndex: "roles",
      key: "roles",
      title: "Роль пользователя",
      width: 200,
      render: (_: any, record: UserListEntity) => {
        return record.roles ? <ListOfRoles roles={record.roles} /> : null;
      },
    },
    {
      dataIndex: "status",
      key: "statuses",
      title: "Статус",
      align: "left",
      width: 130,
      render: (status: UserStatus) => {
        return <Status color={USER_SCOPE_TEXTS.colors[status]} children={USER_SCOPE_TEXTS.texts[status]} />;
      },
    },
  ].filter((c) => !!c) as ColumnType<UserListEntity>[];
};
